import { CopyToClipboardWorkflowNode } from '@blaze-shared/workflow-domain';

import {
  ConnectorProvider,
  WorkflowNodeConnectorProvider,
} from '../../registry/connector-provider.registry';

@WorkflowNodeConnectorProvider('CopyToClipboard')
export class CopyToClipboardConnectorProvider extends ConnectorProvider<CopyToClipboardWorkflowNode> {}
